import {r as a} from '@theme/theme-sections';
import {F as c} from '@theme/flickity';
import {S as d} from '@theme/slider-progress-indicator';
import {s as p} from '@theme/section-slider-lifecycle';
import '@theme/_commonjsHelpers';
const o = 'product-carousel';
var t, r, i;
const h =
    ((i = (r = (t = window.Shopify) == null ? void 0 : t.theme) == null ? void 0 : r.sections) == null
      ? void 0
      : i.registered) || {},
  u = typeof h[o] > 'u',
  s = {slider: '[data-slider]', progressBar: '[data-slider-progress-bar]'};
u &&
  a(o, {
    ...p,
    onLoad() {
      this.teardown(),
        (this.sectionActive = !0),
        (this.slider = null),
        (this.elements = {
          section: this.container.closest('.shopify-section') || this.container,
          slider: this.container.querySelector(s.slider),
          progressBar: this.container.querySelector(s.progressBar),
        }),
        this.initSlider();
    },
    initSlider() {
      const e = this.elements.slider;
      if (!this.isSectionActive() || !e) return;
      this.destroySlider();
      const n = window.matchMedia(`(min-width: ${window.theme.breakpoints.lg}px)`).matches,
        l = {
          style1: {
            prevNextButtons: !0,
            pageDots: !1,
            contain: !0,
            groupCells: !0,
            arrowShape: 'M62.5 77.6517L34.8484 50L62.5 22.3484L65.1517 25L40.1517 50L65.1517 75L62.5 77.6517Z',
          },
          style2: {
            prevNextButtons: !0,
            pageDots: !1,
            cellAlign: n ? 'left' : 'center',
            contain: !0,
            wrapAround: !0,
            arrowShape: 'M63.5813 87.5L26.0813 50L63.5813 12.5',
          },
        };
      (this.slider = new c(e, l[this.container.dataset.style])),
        this.elements.progressBar &&
          (this.progressIndicator = new d({element: this.elements.progressBar, slider: this.slider})),
        this.scheduleSliderResize();
    },
  });
